import React from 'react'

function UserDetail() {
  

    return (
    <div>UserDetail</div>
  )
}

export default UserDetail